import { CheckBoxWithLabelWidget, ExpandoWidget, InlineAlertType, InlineAlertWidget, IntegerStepperWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

interface GeocodeTabProps {
  tokenLimit: number;
  targetColName?: string;
  handleTokenLimitChange: (limit: number) => void;
}

interface GeocodeTabState {
  tokenLimit: number;
  isScheduleChecked: boolean;
}

export class GeocodeTab extends React.PureComponent<GeocodeTabProps, GeocodeTabState> {
  public constructor(props: GeocodeTabProps) {
    super(props);
    this.state = {
      tokenLimit: props.tokenLimit,
      isScheduleChecked: false,
    };
  }

  private handleTokenLimitChange = (limit: number): void => {
    this.setState({tokenLimit: limit});
    this.props.handleTokenLimitChange(limit);
  };

  private buildTokenLimitArea(): React.ReactNode {
    return (
      <>
        <IntegerStepperWidget
          label={Messages.geocodingConfigTokenLimitStepperLabel()}
          max={50000}
          min={0}
          start={this.state.tokenLimit}
          onValueUpdated={this.handleTokenLimitChange}
          testId="geocode-row-count"
        />
        <div className='geocodingInfoTextBlock'>
          <div className='geocodingBoldText'>{Messages.geocodingConfigGeocodeTabInfoTitle()}</div>
          <div>{Messages.geocodingConfigGeocodeTabInfoParagraph()}</div>
        </div>
        <InlineAlertWidget className='geocodingTokenLimitInfo' type={InlineAlertType.Info} testId="">
          {Messages.geocodingConfigTokenLimitInfo()}
        </InlineAlertWidget>
      </>
    );
  }

  private buildScheduleCheckbox(): React.ReactNode {
    return (
      <>
        <CheckBoxWithLabelWidget
          checked={this.state.isScheduleChecked}
          handleChange={(checked) => this.setState({ isScheduleChecked: checked })}
          testId="schedule"
          label={Messages.geocodingConfigGeocodeTabScheduleCheckboxLabel()}
          className='geocodingBoldText'
        />
        <ExpandoWidget label={Messages.geocodingConfigGeocodeTabScheduleExpandoLabel()} testId="schedule" className='geocodeTabLabelIndent'>
          TODO: Schedule component
        </ExpandoWidget>
      </>
    );
  }

  public render(): React.ReactNode {
    if (!this.props.targetColName) {
      return <div>{Messages.geocodingConfigGeocodeTabNoSelection()}</div>;
    }

    return (
      <div>
        <div className='geocodingLargeText'>{Messages.geocodingConfigGeocodeTabHeader()}</div>
        {this.buildTokenLimitArea()}
        {this.buildScheduleCheckbox()}
      </div>
    );
  }
}
